/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_Select_HintInputs */

const en_language_select_hint = /** @type {(inputs: Language_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select your preferred language`)
};

const ja_language_select_hint = /** @type {(inputs: Language_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`希望の言語を選択`)
};

const fr_language_select_hint = /** @type {(inputs: Language_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez votre langue préférée`)
};

const de_language_select_hint = /** @type {(inputs: Language_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugte Sprache auswählen`)
};

/**
* | output |
* | --- |
* | "Select your preferred language" |
*
* @param {Language_Select_HintInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const language_select_hint = /** @type {((inputs?: Language_Select_HintInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_Select_HintInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language_select_hint(inputs)
	if (locale === "ja") return ja_language_select_hint(inputs)
	if (locale === "fr") return fr_language_select_hint(inputs)
	return de_language_select_hint(inputs)
});